import { Button, Form } from "react-bootstrap";
import { Claims, SetPinRequest } from "../../models";
import { useProfileQuery } from "../../queries";
import { Input, StatefulForm, useStatefulForm } from "../../component-library";
import { z } from "zod";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../contexts";

const schema = z.object({
    pin: z.string().length(4, "PIN must be 4 digits"),
});

type PinFormValues = z.infer<typeof schema>;

export function PreferencesForm() {
    const navigate = useNavigate();
    const { hasPermission } = usePermissions();
    const viewInternal = hasPermission(Claims.ViewInternal);
    const { getMyUserProfile, updatePinMutation } = useProfileQuery();
    // const {
    //     meQuery: { data: myPerson },
    // } = usePersonQuery();
    const myUserProfile = getMyUserProfile.data;
    // const emailInput = myUserProfile?.enableEmailNotifications ?? false;
    // const smsInput = myUserProfile?.enableSmsNotifications ?? false;

    const defaultValues = useMemo(() => ({ pin: "" }), []);
    const { methods, isDirty } = useStatefulForm({ defaultValues, schema });

    // const updateProfile = async (request: UserProfile) => {
    //     try {
    //         await updateMyUserProfile.mutateAsync(request);
    //     } catch (error) {
    //         errorToast(error);
    //     }
    // };

    // const toggleEmail = async (enabled: boolean) => {
    //     if (!myUserProfile) return;
    //     const request: UserProfile = {
    //         ...myUserProfile,
    //         enableEmailNotifications: enabled,
    //     };
    //     await updateProfile(request);
    // };

    // const toggleSms = async (enabled: boolean) => {
    //     if (!myUserProfile) return;
    //     const request: UserProfile = {
    //         ...myUserProfile,
    //         enableSmsNotifications: enabled,
    //     };
    //     await updateProfile(request);
    // };

    const handleSetPin = ({ pin }: PinFormValues) => {
        const request: SetPinRequest = {
            pin: Number(pin),
        };
        updatePinMutation.mutate(request);
        navigate("/");
    };

    if (!myUserProfile) return <></>;

    return (
        <>
            {/* <Form.Group controlId="emailNotifications">
                <Form.Check
                    value="emailNotifications"
                    checked={emailInput}
                    onChange={(e) => toggleEmail(e.target.checked)}
                    label="Enable Email Notifications"
                />
            </Form.Group>
            <Form.Group controlId="smsNotifications">
                <Form.Check
                    value="smsNotifications"
                    checked={smsInput}
                    onChange={(e) => toggleSms(e.target.checked)}
                    label="Enable SMS Notifications"
                />
            </Form.Group> */}
            {viewInternal && (
                <StatefulForm onSubmit={(values) => handleSetPin(values as PinFormValues)} methods={methods}>
                    <Input
                        accessor="pin"
                        label="New PIN"
                        type="password"
                        isInvalid={!myUserProfile?.hasPin}
                        maxLength={4}
                    />
                    <Form.Text className="text-muted">Enter 4 digit PIN</Form.Text>
                    <div className="d-flex justify-content-center">
                        <Button type="submit" disabled={!isDirty}>
                            Submit
                        </Button>
                    </div>
                </StatefulForm>
            )}
        </>
    );
}
